import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import WallAppBar from './Components/AppBar/WallAppBar.js';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import logo from './Components/Assets/logo.png';
import { styled , createTheme, ThemeProvider } from '@mui/material/styles';
import './CSS/Images.css';
// import anim from './Components/Assets/anim0.gif'

function AboutPage() {
    const theme = createTheme({
        typography: {
          subtitle1: {
            fontSize: 12,
          },
          h3: {
            fontWeight: 1500,
          },
          h4: {
            fontWeight: 1500,
          },
          h5: {
            fontWeight: 1500,
          }
        },
      });
      const [advs, setAdvs] = useState("easy");
  
      const advsArray = ["easy", "fast", "smooth", "simple", "intuitive"];
      var advsIndex = 0;
  
      useEffect(() => {
          const interval = setInterval(myTimer , 1000);
          return () => {
            clearInterval(interval);
          };
        }, []);
  
      function myTimer() {
          // console.log('timer running', advsArray[advsIndex % advsArray.length] )
          advsIndex++;
          setAdvs(advsArray[advsIndex % advsArray.length])
      }

  return (
    <Box sx={{ flexGrow:1 }} className="App-header">
      {/* <TopAppBar breadcrumbs={breadcrumbs}/> */}
      <WallAppBar />

      <Stack align='center' sx={{height:'100%', alignItems:'center', justifyContent:'center', mt:'60px' }}>
            <ThemeProvider theme={theme}>
                <img src={logo} height="150px" alt="workbench logo" sx={{imageRendering: 'pixelated',}}></img>     
                 
                <Typography sx={{width:'70%', color:'azure', mt:2}} variant="h4" color="text.primary" >
                    We are dedicated to make language learning
                </Typography>
                <Typography sx={{width:'70%', color:'#8ecf5c', mb:2}} variant="h4" color="secondary">
                {advs}.
                </Typography>


                <Typography sx={{ color:'azure'}} variant="h6" color="text.secondary">
                {/* VocabSlab is an intuitive, customizable language app designed to suit your needs.   */}
                  <b>Choose what to learn.</b>
                </Typography>

                <Typography sx={{ color:'azure', mb:1}} variant="body1" color="text.secondary">
                  We will only show you words that you selected.
                </Typography>

                <Typography sx={{color:'azure'}} variant="h6" color="text.secondary">
                  <b>Track your progress.</b>
                </Typography>

                <Typography sx={{ color:'azure' , mb:1}} variant="body1" color="text.secondary">
                  Check your familiarity score with each word.
                </Typography>

                <Typography sx={{color:'azure'}} variant="h6" color="text.secondary">
                  <b>Learn Audiovisually.</b>
                </Typography>

                <Typography sx={{ color:'azure'}} variant="body1" color="text.secondary">
                  Pictures and audio cues for words in all 16 languages.
                </Typography>

                <Typography sx={{ color:'azure', mt:2, opacity:'60%'}} variant="body2" color="text.secondary">
                  Contact: jasonlin-97 [alpha tango] hotmail.com
                </Typography>
            </ThemeProvider>
        </Stack>

    </Box>
  );
}

export default AboutPage;